var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealthAssess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#084F8A",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 13.5534C17.2334 13.3534 17.6867 12.9001 17.8867 12.3334H20L18 17.0001C18 18.1067 19.0467 19.0001 20.3334 19.0001C21.62 19.0001 22.6667 18.1067 22.6667 17.0001L20.6667 12.3334H22V11.0001H17.8867C17.6134 10.2201 16.8734 9.66675 16 9.66675C15.1267 9.66675 14.3867 10.2201 14.1134 11.0001H10V12.3334H11.3334L9.33337 17.0001C9.33337 18.1067 10.38 19.0001 11.6667 19.0001C12.9534 19.0001 14 18.1067 14 17.0001L12 12.3334H14.1134C14.3134 12.9001 14.7667 13.3534 15.3334 13.5534V21.0001H9.33337V22.3334H22.6667V21.0001H16.6667V13.5534ZM21.58 17.0001H19.0867L20.3334 14.0934L21.58 17.0001ZM12.9134 17.0001H10.42L11.6667 14.0934L12.9134 17.0001ZM16 12.3334C15.6334 12.3334 15.3334 12.0334 15.3334 11.6667C15.3334 11.3001 15.6334 11.0001 16 11.0001C16.3667 11.0001 16.6667 11.3001 16.6667 11.6667C16.6667 12.0334 16.3667 12.3334 16 12.3334Z",
    fill: "#027BCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthAssess);
export default __webpack_public_path__ + "static/media/healthAssess.99c482858de3a2e1d02e347f2afd6bac.svg";
export { ForwardRef as ReactComponent };